import { computeFootprintBars } from "../utils";
const Footprint = {
    name: "Footprint",
    compute: (bars, barIntervalMs = 60000, priceTickSize = 0.01) => {
        return computeFootprintBars(bars, barIntervalMs, priceTickSize);
    },
    render: () => undefined,
};
export default Footprint;
